document.addEventListener("DOMContentLoaded", () => {
  const preloader = document.getElementById("preloader");

  if (preloader) {
    // Check if the current URL is the root domain
    if (window.location.pathname === "/") {
      setTimeout(() => {
        preloader.classList.add("hide");
        
        // Remove the preloader entirely after the transition
        setTimeout(() => {
          preloader.style.display = "none";
        }, 500); // Wait for CSS transition to complete
      }, 2000); // Adjust timing for the preloader display
    } else {
      // Immediately hide the preloader if not on the root domain
      preloader.style.display = "none";
    }
  }
});
